export const pluralize = (val, str1, str2) => (val > 1 ? str1 : str2 || "");
